import { PermissionsGate } from 'features/permissions'
import type { FC, ReactNode } from 'react'
import {
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_MODUS,
  RolodexPermissionsValues,
} from 'types'

export const AI_PREFILL_BUTTON_LABELS = {
  idle: 'Pre-fill with AI',
  loading: 'Pre-filling with AI...',
  repeat: 'Pre-fill with AI again',
  all: 'Pre-fill all with AI',
  loadingAll: 'Pre-filling all with AI...',
  repeatAll: 'Pre-fill all with AI again',
} as const

export function prefillLabel({
  loading,
  hasRun,
}: {
  loading: boolean
  hasRun: boolean
}) {
  if (loading) return AI_PREFILL_BUTTON_LABELS.loading
  return hasRun
    ? AI_PREFILL_BUTTON_LABELS.repeat
    : AI_PREFILL_BUTTON_LABELS.idle
}

export function prefillAllLabel({
  loading,
  hasRun,
}: {
  loading: boolean
  hasRun: boolean
}) {
  if (loading) return AI_PREFILL_BUTTON_LABELS.loadingAll
  return hasRun
    ? AI_PREFILL_BUTTON_LABELS.repeatAll
    : AI_PREFILL_BUTTON_LABELS.all
}

export const AiPrefillGate: FC<{
  permissions: RolodexPermissionsValues[]
  children: ReactNode
}> = ({ permissions, children }) => (
  <PermissionsGate
    requires={[
      PERMISSION_GECKO_INTERNAL_MEMBER,
      PERMISSION_MODUS,
      ...permissions,
    ]}>
    {children}
  </PermissionsGate>
)
